import { MAX_HP } from "../constants.js";
import { MAP_DEFS } from "./maps.js";

const STORAGE_KEY = "hene.worldState.v1";

export const WORLD_STATE = {
  hp: MAX_HP,
  lastMapId: "village",
  spawnOverride: null,
  resumeEnabled: true,
  lastStanding: null,
  lastStandingSavedAtMs: 0,
  inventory: {},
};

function isFiniteNumber(v) {
  return typeof v === "number" && Number.isFinite(v);
}

function sanitizeLastStanding(v) {
  if (!v || typeof v !== "object") return null;
  if (typeof v.mapId !== "string" || !MAP_DEFS[v.mapId]) return null;
  if (!isFiniteNumber(v.x) || !isFiniteNumber(v.y)) return null;
  return { mapId: v.mapId, x: v.x, y: v.y };
}

export function loadWorldStateFromStorage() {
  try {
    const raw = globalThis?.localStorage?.getItem(STORAGE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return;

    if (isFiniteNumber(parsed.hp)) {
      WORLD_STATE.hp = Math.max(0, Math.min(MAX_HP, parsed.hp));
    }
    if (typeof parsed.lastMapId === "string" && MAP_DEFS[parsed.lastMapId]) {
      WORLD_STATE.lastMapId = parsed.lastMapId;
    }
    if (typeof parsed.resumeEnabled === "boolean") {
      WORLD_STATE.resumeEnabled = parsed.resumeEnabled;
    }
    if (parsed.inventory && typeof parsed.inventory === "object") {
      WORLD_STATE.inventory = parsed.inventory;
    }
    WORLD_STATE.lastStanding = sanitizeLastStanding(parsed.lastStanding);
  } catch {
    // Ignore corrupted/missing storage and keep defaults.
  }
}

export function saveWorldStateToStorage() {
  try {
    const payload = {
      hp: WORLD_STATE.hp,
      lastMapId: WORLD_STATE.lastMapId,
      resumeEnabled: WORLD_STATE.resumeEnabled,
      lastStanding: sanitizeLastStanding(WORLD_STATE.lastStanding),
      inventory: WORLD_STATE.inventory,
    };
    globalThis?.localStorage?.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Ignore storage write failures.
  }
}

export function clearSavedResume() {
  WORLD_STATE.lastStanding = null;
  WORLD_STATE.lastStandingSavedAtMs = 0;
  try {
    globalThis?.localStorage?.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
